<template>
	<footer :class="[channel.skin_background_footer ? 'bg-'+channel.skin_background_footer : 'bg-dark', channel.skin_footer_text ? 'text-'+channel.skin_footer_text : 'text-light']"
			v-if="showFooter()">
		<b-container>
			<b-row 	align-v="center"
					class="py-4 py-lg-6">
				<b-col 	cols="12"
						class="text-center">
					<hr lass="py-5">
					<p class="m-0 smallest pt-4 pt-lg-6">&copy; Skandinaviska Enskilda Banken AB (publ)</p>
				</b-col>
			</b-row>
		</b-container>
	</footer>
</template>
<script>
	export default {
		computed: {
			asset() {
				return this.$store.getters.asset
			},
			channel() {
				return this.$store.getters.channel
			},
			stream() {
				return this.$store.getters.stream
			}
		},
		methods: {
			showFooter() {
				if(this.$route.name === 'preview') return true
				if(this.$route.name === 'asset' && this.asset && (this.asset.broadcasting === 1 && this.stream)) return true
				if(this.$route.name === 'asset' && this.asset && (this.asset.broadcasting === 1 && this.asset.type === 5)) return true
				if(this.$route.name === 'asset' && this.asset && this.asset.type === 1) return true
				if(this.$route.name === 'asset' && this.asset && this.asset.type === 4 && this.asset.status_id == 5) return true
				return false
			}
		}
	}
</script>
